// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__jFX1j"};